import {DI} from '../types'
import {ContainerModule, ContainerModuleLoadOptions} from 'inversify'

import {FavouriteRepositoryInterface, ToggleFavouriteUseCase} from '@/src/core/application/favourite'

import {FavouriteRepository} from '@/src/features/favourite/infrastructure/repository'

import {FavouriteStore, FavouriteStoreInterface} from '@/src/presentation/stores/favourite'

const initializeModule = ({bind}: ContainerModuleLoadOptions) => {
  bind<FavouriteRepositoryInterface>(DI.FavouriteRepositoryInterface).to(FavouriteRepository)
  bind<ToggleFavouriteUseCase>(DI.ToggleFavouriteUseCase).to(ToggleFavouriteUseCase)
  bind<FavouriteStoreInterface>(DI.FavouriteStoreInterface).to(FavouriteStore)
}

export const FavouriteModule = new ContainerModule(initializeModule)
